import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../Styles/GalleryForm.css";
import { fileAPI, galleryAPI } from "../../api/index"; // adjust to your actual api file path

export const CATEGORY_OPTIONS = [
  { label: "Leaders", value: "leaders" },
  { label: "Events", value: "events" },
  { label: "Spiritual", value: "spiritual" },
  { label: "Inaugurations", value: "inaugurations" },
  { label: "Sports", value: "sports" },
  { label: "Others", value: "others" },
];

function GalleryForm() {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState("active");
  const [caption, setCaption] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleImageChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
      setPreview(URL.createObjectURL(selected));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!file) {
      setError("Please choose a photo to upload.");
      return;
    }

    setSubmitting(true);
    try {
      // Step 1: upload the raw file, subfolder must be "gallery" per your Swagger dropdown
      const uploadRes = await fileAPI.upload(file, "gallery");

      // Step 2: pull the URL out of whatever shape the backend returns
      const photoUrl =
        uploadRes.data?.url ||
        uploadRes.data?.file_url ||
        uploadRes.data?.photo_url;

      if (!photoUrl) {
        throw new Error(
          "Upload succeeded but the response didn't contain a usable URL field."
        );
      }

      // Step 3: create the gallery record referencing that uploaded file
      await galleryAPI.create({
        title,
        category, // already lowercase to match backend pattern
        caption: caption || null,
        status,
        photo_url: photoUrl,
      });

      navigate("/dashboard/GalleryTable");
    } catch (err) {
      console.error("Gallery photo save failed:", err);
      setError(
        err.response?.data?.detail ||
          err.message ||
          "Something went wrong while saving the photo."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Add Photo to Gallery</h2>
        <button className="back-btn-gallery" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>

      <form className="gallery-form" onSubmit={handleSubmit}>
        {error && <div className="gallery-form-error">{error}</div>}

        <div className="form-row">
          <div className="form-group">
            <label>Photo Title</label>
            <input
              type="text"
              placeholder="Enter Photo Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Category</label>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              required
            >
              <option value="" disabled>
                Select Category
              </option>
              {CATEGORY_OPTIONS.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Upload Photo</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Status</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        {preview && (
          <div className="gallery-preview-box">
            <img src={preview} alt="Preview" className="gallery-preview-img" />
          </div>
        )}

        <div className="form-group">
          <label>Caption / Description</label>
          <textarea
            rows="4"
            placeholder="Optional Caption"
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
          ></textarea>
        </div>

        <button className="sub-btn-gallery" type="submit" disabled={submitting}>
          {submitting ? "Uploading..." : "Submit Photo"}
        </button>
      </form>
    </div>
  );
}

export default GalleryForm;